<template>
    <div class="comment comment-margin cf">

        <div class="avatar fl">

            <img :src="user.head_pic || require('../../assets/images/avatar.png')" />

        </div>

        <!-- 评论部分 -->
        <div class="comment-input fr">

            <textarea type="text" v-model="comment" placeholder="给你一个神评的机会..."></textarea>

            <div class="comment-button button-active" @click="send">发布</div>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-comment-input",
    mixins: [mixin],
    props: {
        id: {
            type: [Number,String],
            default: 1
        },
        type: {             // 5.话题 6.资讯 7.帖子
            type: Number,
            default: 0
        }
    }
}
</script>

<style scoped src="./style.css"></style>
